module.exports = __webpack_public_path__ + "static/media/card-placeholder_full.111d9a6f.svg";